import { templateTags } from "../constants";

export const editorLabelTag = (label: string) => {
  return `<span class='joditTag'> ${label} </span> &nbsp;`;
};

export const addTagsToString = (strToReplace: string) => {
  const patternTag = /@([\w]*\.)+[\w]+/gm;

  return strToReplace.replace(patternTag, `<span class='joditTag'> $& </span> &nbsp;`);
};

export const removeHTML = (strToReplace: string) => {
  return strToReplace.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, "");
};

export const tagsValidator = (content: string) => {
  const patternTag = /<span class="joditTag">(.*?)<\/span>/gm;
  const arrayOfMatches = content.match(patternTag);
  let invalidTag = "";
  const clenArrayOfMatches = arrayOfMatches?.map((item) => removeHTML(item).replace(/\s/g, ""));
  let isValid = true;
  const allTagsOptions = Object.entries(templateTags).flatMap((subgroup) =>
    Object.entries(subgroup[1]).flatMap((item) => item[0])
  );

  clenArrayOfMatches?.forEach((tag) => {
    if (!allTagsOptions.includes(tag)) {
      invalidTag = tag;
      isValid = false;
    }
  });
  if (isValid) invalidTag = "";

  return { isValid, invalidTag };
};

export const tagsSMSValidator = (content: string) => {
  const patternTag = /<span class="joditTag">(.*?)<\/span>/gm;
  const tagsWithoutErrorStyle = content.replace(/joditErrorTag/g, "joditTag");

  const arrayOfMatches = tagsWithoutErrorStyle.match(patternTag);
  let invalidTag = "";
  const clenArrayOfMatches = arrayOfMatches?.map((item) => removeHTML(item).replace(/\s/g, ""));
  let isValid = true;
  const allTagsOptions = Object.entries(templateTags).flatMap((subgroup) =>
    Object.entries(subgroup[1]).flatMap((item) => item[0])
  );
  let contentTags = tagsWithoutErrorStyle;
  const invalidTags: string[] = [];

  clenArrayOfMatches?.forEach((tag) => {
    if (!allTagsOptions.includes(tag)) {
      invalidTag = tag;
      invalidTags.push(tag);
      isValid = false;
    }
  });

  if (invalidTags.length && invalidTags.length > 0) {
    invalidTags.forEach((invalidTag) => {
      const tagToReplacePattern = new RegExp(
        `<span class="joditTag">(&nbsp;| )*\\s*(${invalidTag})(&nbsp;| )*\\s*</span>`
      );

      contentTags = contentTags.replace(
        tagToReplacePattern,
        `<span class="joditErrorTag"> ${invalidTag} </span>`
      );
    });
  }

  if (isValid) invalidTag = "";

  return { isValid, invalidTag, invalidTags, contentTags };
};

export const handleInsertTemplateTag = (
  editor: { selection: { insertHTML: (arg0: string) => void } },
  nodeOrFalse: Node | null,
  control: { control: { name: string; args: string[] } }
) => {
  if (control?.control?.args?.[0])
    editor.selection.insertHTML(editorLabelTag(control?.control?.args?.[0]));
};
